const getHeaderObject = () => {
  return {
    header: {
      display: "flex",
      gridColumn: 1 / 3,
      alignItems: "center",
      padding: "10px",
      backgroundColor: "white",
      borderBottom: "1px solid #0304041a",
      width: "100%",
      zIndex: 2001,
      position: "fixed",
      top: 0,
      left: 0,
    },
    headerForMobile: {
      alignItems: "center",
      backgroundColor: "white",
      width: "100%",
      zIndex: 2000,
      position: "fixed",
      top: 0,
    },
    headerNameDiv: {
      display: "flex",
    },
    nameAbbrContainer: {
      width: "3.6rem",
      aspectRatio: 1,
      backgroundColor: "#0D47A1",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "0.25rem",
      color: "white",
    },
    nameAbbrText: {
      margin: 0,
      fontSize: "28px",
    },
    nameDetailsContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "start",
      marginLeft: "10px",
    },
    ageAndDob: {
      margin: 0,
      padding: "5px",
    },
    ageAndDobValue: {
      margin: 0,
      backgroundColor: "#F7F9FA",
      padding: "5px",
    },
    buttonsContainer: {
      display: "flex",
      gap: "1rem",
      color: "#0D47A1",
      textTransform: "none",
    },
    button: {
      fontWeight: "bold",
      color: "#0D47A1",
      borderColor: "#0D47A1",
      textTransform: "none",
      padding: "5px 15px",
    },
  };
};

export const getHeaderStyle = getHeaderObject;
